import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../constants";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";

export type AnswerStatus = "correct" | "incorrect" | "skipped";

type AnswerStatusChipProps = {
	status: AnswerStatus;
	label: string;
	fontSize?: number;
	minWidth?: number;
	gap?: number;
};

const AnswerStatusChip = ({
	status,
	label,
	fontSize = 14,
	minWidth = 68,
	gap = 8,
}: AnswerStatusChipProps) => {
	const theme = useAppTheme();
	const getBgColor = () => {
		switch (status) {
			case "correct":
				return theme.palette.confidence.high;
			case "incorrect":
				return theme.palette.confidence.low;
			case "skipped":
				return theme.palette.progress.noneBackground;
			default:
				return undefined;
		}
	};

	const getIcon = () => {
		switch (status) {
			case "correct":
				return "check" as const;
			case "incorrect":
				return "close" as const;
			default:
				return "minus-circle-outline" as const;
		}
	};
	return (
		<Box
			style={{
				backgroundColor: getBgColor(),
				minWidth,
				minHeight: 32,
				borderRadius: theme.roundness * themeRoundnessMultiplier,
				padding: 6,
			}}
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={gap}
		>
			<Icon name={getIcon()} size={18} color={theme.colors.white} />
			<Text
				variant="labelMedium"
				style={{
					color: theme.colors.white,
					fontSize,
					lineHeight: 0,
				}}
			>
				{label}
			</Text>
		</Box>
	);
};

export default AnswerStatusChip;
